import { render, staticRenderFns } from "./CurrentShift.vue?vue&type=template&id=2a021dc0&lang=pug&"
import script from "./CurrentShift.vue?vue&type=script&lang=js&"
export * from "./CurrentShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports